import { render, staticRenderFns } from "./number-scale-response.vue?vue&type=template&id=06faf291&scoped=true&"
import script from "./number-scale-response.vue?vue&type=script&lang=js&"
export * from "./number-scale-response.vue?vue&type=script&lang=js&"
import style0 from "./number-scale-response.vue?vue&type=style&index=0&id=06faf291&scoped=true&lang=scss&"
import style1 from "./number-scale-response.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faf291",
  null
  
)

component.options.__file = "number-scale-response.vue"
export default component.exports